export default __webpack_public_path__ + "static/media/Purpose.fa97d39d.jpg";